import React, { memo, forwardRef } from 'react';
import type { InputProps as ThemedInputProps } from 'theme-ui';
import { Input, Box, Button } from 'theme-ui';
interface InputPropsMax extends ThemedInputProps {
  onMaxClick: any; // onclick fn for MAX
  value: string; // require controlled
  onChange: any; // require controlled
}

export const InputMax = memo(
  forwardRef<HTMLInputElement, InputPropsMax>(
    ({ onMaxClick, disabled, ...props }, ref) => (
      <Box>
        <Box sx={{ position: 'relative' }}>
          <Input
            {...props}
            disabled={disabled}
            sx={{ ...props.sx }}
            ref={ref}
          />
          {onMaxClick && (
            <Box
              sx={{
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                position: 'absolute',
                top: 0,
                right: 0,
              }}
            >
              <Button
                disabled={disabled}
                onClick={onMaxClick}
                variant="max"
                bg="text"
                m="auto"
                mr={2}
              >
                Max
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    )
  )
);
